import Icon from '../Icon';

const PlusIcon = (props) => {
  const { color, ...rest } = props;
  return (
    <Icon viewBox="0 0 24 24" {...rest}>
      <path
        d="M12 18V6"
        stroke={color}
        strokeWidth="1.7"
        strokeLinecap="round"
      />
      <path
        d="M6 12L18 12"
        stroke={color}
        strokeWidth="1.7"
        strokeLinecap="round"
      />
    </Icon>
  );
};

export default PlusIcon;
